export const intervalTime = {
    // 保持连接，防止session过期
    connectTime: 9 * 60 * 1000
}
